module.exports = __webpack_public_path__ + "img/2@3x.d9c86104.png";